/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { css, ClassNames } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import IconCircledRightArrow from '../../ComponentLibrary/icons/icon-circled-right-arrow';
import Theme from '../../../themes';

const sliderStyles = css`
  margin-bottom: 16px;
  padding-bottom: 16px;

  .slick-list {
    left: -16px;
    width: calc(100% + 32px);
  }
`;

const arrowStyles = css`
  cursor: pointer;
  height: 38px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 38px;
  z-index: 10;

  @media (max-width: 1199px) {
    height: 24px;
    width: 24px;
  }
`;

const nextArrowStyles = css`
  ${arrowStyles};
  right: -46px;

  @media (max-width: 1199px) {
    right: -28px;
  }
`;

const prevArrowStyles = css`
  ${arrowStyles};
  left: -46px;
  transform: translateY(-50%) scaleX(-1);

  @media (max-width: 1199px) {
    left: -28px;
  }
`;

const ItemContainer = styled.div`
  padding: 8px 16px;
`;

const brandedDotStyles = css`
  bottom: 0px;

  li {
    margin: 0 4px;
    height: 14px;
    width: 14px;

    button {
      height: 24px;
      width: 24px;
      position: relative;
      background-color: transparent;
      border-radius: 100%;

      &:before {
        border-radius: 100%;
        content: '';
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 14px;
        width: 14px;
        background-color: #a8a8a8;
        position: absolute;
        box-sizing: border-box;
      }
    }

    &.slick-active {
      button {
        &:before {
          background-color: ${Theme.colors.brand};
          border: 1px solid ${Theme.colors.brand};
          box-shadow: 0 0 0 3px #fff, 0 0 0 4px ${Theme.colors.brand};
        }
      }
    }
  }
`;

const CarouselArrow = ({ className, onClick, prevArrow }) =>
  !className?.includes('slick-disabled') && (
    <div css={prevArrow ? prevArrowStyles : nextArrowStyles} onClick={onClick}>
      <IconCircledRightArrow />
    </div>
  );

const CardSetCarousel = ({ children, itemsPerRow = 3, itemsPerRowTablet = 2, itemsPerRowMobile = 1 }) => {
  const sliderRef = useRef(null);
  const items = children?.slice(0, 6);
  // passing these as strings to the Slider results in busted pagination
  const itemsPerRowNum = JSON.parse(itemsPerRow);
  const itemsPerRowTabletNum = JSON.parse(itemsPerRowTablet);
  const itemsPerRowMobileNum = JSON.parse(itemsPerRowMobile);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0, true);
    }
  }, [items]);

  if (!items) {
    return null;
  }

  return (
    <ClassNames>
      {classNames => (
        <Slider
          css={sliderStyles}
          dots
          dotsClass={`hero-slick-dots ${classNames.css(brandedDotStyles)}`}
          swipe
          infinite={false}
          nextArrow={<CarouselArrow />}
          prevArrow={<CarouselArrow prevArrow />}
          slidesToShow={itemsPerRowNum}
          slidesToScroll={itemsPerRowNum}
          ref={sliderRef}
          responsive={[
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: itemsPerRowTabletNum,
                slidesToScroll: itemsPerRowTabletNum,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: itemsPerRowMobileNum,
                slidesToScroll: itemsPerRowMobileNum,
              },
            },
          ]}
        >
          {items.map(card => (
            <ItemContainer>{card}</ItemContainer>
          ))}
        </Slider>
      )}
    </ClassNames>
  );
};

export default CardSetCarousel;
